import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token') || null);
    const [key, setKey] = useState(0); // Add a key state

    useEffect(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            // Optionally, fetch user data with the token
            axios.get(`${process.env.REACT_APP_API_BASE_URL}/user`)
                .then(response => {
                    const updatedUserData = PrepareUserData(token, response.data);
                    setUser(updatedUserData);
                    setKey(prevKey => prevKey + 1); // Update the key to trigger a re-render
                })
                .catch(error => {
                    setUser(null);
                    setKey(prevKey => prevKey + 1); // Update the key to trigger a re-render
                });
        } else {
            delete axios.defaults.headers.common['Authorization'];
        }
    }, [token]);

    const login = (userData, token) => {
        const updatedUserData = PrepareUserData(token, userData);
        setUser(updatedUserData);
        setToken(token);
        localStorage.setItem('token', token);
        setKey(prevKey => prevKey + 1); // Update the key to trigger a re-render
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setKey(prevKey => prevKey + 1); // Update the key to trigger a re-render
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            <div key={key}>{children}</div> {/* Use the key to force a re-render */}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export function decodeToken(token) {
    if (!token) return null;
    try {
        return jwtDecode(token);
    } catch (e) {
        console.error('Invalid JWT', e);
        return null;
    }
}
function PrepareUserData(token, userData) {
    const decodedToken = decodeToken(token);

    // Set isAdmin based on the IsAdmin claim in the token
    const isAdmin = decodedToken.IsAdmin === "true";
    const updatedUserData = { ...userData, isAdmin };
    return updatedUserData;
}
